import produce from "immer"
import { IDLE } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initCcReviewDocumentState: types.CcReviewDocumentState = {
    baseRoute: null,
    activeTab: null,

    fileList: [],
    activeFile: null,
    activeVersion: null,

    loadState: IDLE,
}

const ccReviewDocumentReducer = produce((
    draft: types.CcReviewDocumentState = initCcReviewDocumentState,
    action: ActionTypes = null,
): types.CcReviewDocumentState => {
    switch (action.type) {
        case types.CC_REVIEW_DOCUMENT_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.CC_REVIEW_DOCUMENT_ACTIVE_TAB:
            draft.activeTab = action.activeTab
            return draft

        case types.CC_REVIEW_DOCUMENT_FILE_LIST:
            draft.fileList = action.fileList
            return draft

        case types.CC_REVIEW_DOCUMENT_ACTIVE_FILE:
            draft.activeFile = action.file
            return draft

        case types.CC_REVIEW_DOCUMENT_ACTIVE_VERSION:
            draft.activeVersion = action.version
            return draft

        case types.CC_REVIEW_DOCUMENT_LOAD_STATE:
            draft.loadState = action.state
            return draft

        default:
            return draft
    }
})
export default ccReviewDocumentReducer
